import moment from 'moment';

function safeParseInt(value: unknown): number|string {
  if (typeof value === 'string' && (value as string).trim() !== '') {
    const isNum = parseInt(value, 10);
    return Number.isNaN(isNum) ? value.toLowerCase() : isNum;
  }
  if (typeof value === 'number') {
    return value;
  }
  return '';
}

type ObjType = {
  [key: string]: unknown;
}

export function compareNumbers(a: number, b: number): number {
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  return 0;
}

export function compare(a: ObjType, b: ObjType, orderBy: string): number {
  let internalA = safeParseInt(a[orderBy]);
  let internalB = safeParseInt(b[orderBy]);
  if (typeof internalA === 'number' && typeof internalB === 'number') {
    return compareNumbers(internalA, internalB);
  }
  if (typeof internalA === 'number') {
    internalA = internalA.toString();
  }
  if (typeof internalB === 'number') {
    internalB = internalB.toString();
  }
  return internalA.localeCompare(internalB);
}

export function sortByString<T extends {[key: string]: unknown}>(
  order: string|boolean|undefined, orderBy: string,
): (arg0: T, arg1: T) => number {
  return order === 'asc'
    ? (a, b): number => compare(a, b, orderBy)
    : (a, b): number => -compare(a, b, orderBy);
}

export function sortByDate(
  order: string|boolean|undefined, orderBy: string,
): (arg0: any, arg1: any) => number {
  return order === 'asc'
    ? (a, b): number => (new Date(a[orderBy]) as any) - (new Date(b[orderBy]) as any)
    : (a, b): number => (new Date(b[orderBy]) as any) - (new Date(a[orderBy]) as any);
}

type YearApartType = {
  displayValue: string;
  value: string;
};
export const getYearsApartInArray = (): YearApartType[] => {
  const startYear = moment().year(2018);
  const yearsArray = [startYear.year()];
  const currentYear = moment();
  const yearsApart = currentYear.diff(startYear, 'year') + 1;
  for (let i = 1; i <= yearsApart; i += 1) {
    yearsArray.push(yearsArray[i - 1] + 1);
  }

  return yearsArray.map((year) => ({ displayValue: year.toString(), value: year.toString() }));
};
